import React, { useState } from 'react'
import { EXPLOER } from '../helper/constant';
import { ClipLoader } from 'react-spinners';
import TabButton from './TabButton';
import { formatPrice, trimAddress } from '../helper/functions';
import MyWallet from './MyWallet';
import TopTabButton from './TopTabButton';


export default function TopUsers({ setTab, tab, commonStats, accStats }) {
    const [toptab, setToptab] = useState(0)
    const override = {
        display: "block",
        marginRight: "auto",
        marginLeft: "auto"
    };
    return (
        <div className='row mb-4 d-flex justify-content-center'>
            <div className='col-12 col-xl-7'>
                <TabButton setTab={setTab} tab={tab} />
                <TopTabButton toptab={toptab} setToptab={setToptab} />
                <div className='table-responsive'>
                    <table class="table table-bordered border-primary table-unstake">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">User Address</th>
                                <th scope="col">Total Deposit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {commonStats.loading ? (
                                <tr>
                                    <td colSpan={10} className='p-4'>
                                        <ClipLoader
                                            color="#fff"
                                            loading={true}
                                            cssOverride={override}
                                            size={50}
                                        // className="spinner"
                                        />
                                    </td>
                                </tr>
                            ) : (

                                toptab === 0 ? (
                                    <>
                                        {commonStats.currentWeekTop.length > 0 ? (
                                            commonStats.currentWeekTop.map((rowdata, index) => {
                                                return (
                                                    rowdata[0] !== '0x0000000000000000000000000000000000000000' && (
                                                        <tr key={index}>
                                                            <th>{index + 1}</th>
                                                            <td>
                                                                <a
                                                                    href={`${EXPLOER}/address/${rowdata[0]}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    {rowdata[0] ? trimAddress(rowdata[0]) : '-'}
                                                                </a>
                                                            </td>
                                                            <td>{rowdata[1] ? formatPrice(rowdata[1] / Math.pow(10, 18)) : ' - '} BNB</td>
                                                        </tr>
                                                    )
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={10}>
                                                    <h5 className="p-5 text-white text-center">You Have No Earn Record Yet.</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {commonStats.lastWeekWinner.length > 0 ? (
                                            commonStats.lastWeekWinner.map((rowdata, index) => {
                                                return (
                                                    rowdata[0] !== '0x0000000000000000000000000000000000000000' && (
                                                        <tr key={index}>
                                                            <th>{index + 1}</th>
                                                            <td>
                                                                <a
                                                                    href={`${EXPLOER}/address/${rowdata[0]}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    {rowdata[0] ? trimAddress(rowdata[0]) : '-'}
                                                                </a>
                                                            </td>
                                                            <td>{rowdata[1] ? formatPrice(rowdata[1] / Math.pow(10, 18)) : ' - '} BNB</td>
                                                        </tr>
                                                    )
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={10}>
                                                    <h5 className="p-5 text-white text-center">You Have No Earn Record Yet.</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )

                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <MyWallet accStats={accStats} />
        </div>
    )
}
